<!--
<a class="button button--primary" style="margin-bottom: 16px;" *ngIf="!showSearch" (click)="searchIsVisible(true)">
    <i class="material-icons button__icon">&#xE8B6;</i>
    <span class="button__text">{{Translate('Search')}}</span>
</a> -->
<div class="panel panel--search" *ngIf="!showSearch">
    <div class="panel__header">
        <a class="button button--primary" style="margin-bottom: 16px;" (click)="searchIsVisible(true)">
            <i class="material-icons button__icon">&#xE8B6;</i>
            <span class="button__text">{{Translate('Search')}}</span>
        </a>
        <div class="panel__header__buttons">
            <div *ngFor="let favorite of userFavorites" class="favourites">
                <a class="button button--hover-icon" [ngStyle]="{'background-color':favorite.BackgroundColor}">
                    <span class="button__text" [ngStyle]="{'color':favorite.TextColor}" (click)="getFavorite(favorite.Id)">{{favorite.Name}}</span>
                    <i class="material-icons button__icon" [ngStyle]="{'color':favorite.TextColor}" matTooltip="Edit Favourite"
                        [matMenuTriggerFor]="menu">more_vert</i>
                </a>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="getFavorite(favorite.Id)">
                        <mat-icon>search</mat-icon>
                        <span>{{Translate('Search')}}</span>
                    </button>
                    <button mat-menu-item (click)="openDialog(2,favorite)">
                        <mat-icon>edit</mat-icon>
                        <span>{{Translate('Update to Current Selection')}}</span>
                    </button>
                    <button mat-menu-item (click)="openDialog(3,favorite)">
                        <mat-icon>delete_forever</mat-icon>
                        <span>{{Translate('Delete')}}</span>
                    </button>
                </mat-menu>
            </div>
            <div class="divider"></div>
            <a class="button" (click)="openDialog(1,null)">
                <i class="material-icons button__icon">favorite</i>
                <span class="button__text">{{Translate('Create Favourite')}}</span>
            </a>
           
             <div class="icon" style="cursor: pointer;" (click)="showAlertDialog()"  *ngIf="EnableDashboardAlerts" >
                <mat-icon >notifications_none</mat-icon>
                <div  class="txt"  *ngIf="showText" style="cursor: pointer;" >{{numberofNotifications}}</div>
            </div>  
        </div>
    </div>
</div>


<div class="panel panel--search" *ngIf="showSearch" [@enterAnimation]>
    <div class="panel__header">
        <div class="header__title-container" matTooltip="Hide Search" (click)="searchIsVisible(false);ResetButtonClick()">
            <i class="material-icons title-container__close">close</i>
            <span class="panel__header__title">{{Translate('Search')}}</span>
        </div>
        <div class="panel__header__buttons">
            <div *ngFor="let favorite of userFavorites" class="favourites">
                <a class="button button--hover-icon" [ngStyle]="{'background-color':favorite.BackgroundColor}">
                    <span class="button__text" [ngStyle]="{'color':favorite.TextColor}" (click)="getFavorite(favorite.Id)">{{favorite.Name}}</span>
                    <i class="material-icons button__icon" [ngStyle]="{'color':favorite.TextColor}" matTooltip="Edit Favourite"
                        [matMenuTriggerFor]="menu">more_vert</i>
                </a>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="getFavorite(favorite.Id)">
                        <mat-icon>search</mat-icon>
                        <span>{{Translate('Search')}}</span>
                    </button>
                    <button mat-menu-item (click)="openDialog(2,favorite)">
                        <mat-icon>edit</mat-icon>
                        <span>{{Translate('Update to Current Selection')}}</span>
                    </button>
                    <button mat-menu-item (click)="openDialog(3,favorite)">
                        <mat-icon>delete_forever</mat-icon>
                        <span>{{'Delete' | translate | async}}</span>
                    </button>
                </mat-menu>
            </div>
            <div class="divider"></div>
            <a class="button" (click)="openDialog(1,null)">
                <i class="material-icons button__icon">favorite</i>
                <span class="button__text">{{Translate('Create Favourite')}}</span>
            </a>
             <div class="icon" style="cursor: pointer;" (click)="showAlertDialog()"*ngIf="EnableDashboardAlerts" >
                <mat-icon >notifications_none</mat-icon>
                <div  class="txt"  *ngIf="showText" style="cursor: pointer;" >{{numberofNotifications}}</div>
            </div>  
        </div>
    </div>
    <div class="panel__content">
        <form class="header-form">
            <!-- Dealer-->
            <mat-form-field class="header-form-full-width">
                    <mat-chip-list #dealerChipList>
                      <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(21)" [selectable]="false"
                          [removable]="true" (removed)="popMultipleSelection(21, item.SearchId, item.SearchStr)">
                          {{item.Title}}
                          <mat-icon matChipRemove>cancel</mat-icon>
                      </mat-chip>
                      <input matInput [matChipInputFor]="dealerChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                          [matChipInputAddOnBlur]="false" #dealerAutoCompleteInput (focus)="focus(21)" placeholder="{{ Translate('Dealer')}}"
                          aria-label="dealer" [matAutocomplete]="autoDealer" [formControl]="dealerCtrl"  >
                  </mat-chip-list>
                  <mat-autocomplete #autoDealer="matAutocomplete" [displayWith]="dealerDisplayMapper"
                      (optionSelected)="dealerSelected($event,dealerAutoCompleteInput )">
                      <mat-option *ngFor="let dealer of filteredDealer | async" [value]="dealer">

                          <span>{{ dealer.Title }}</span>
                          <small></small>
                      </mat-option>
                  </mat-autocomplete>
                </mat-form-field>




            <mat-form-field class="header-form-full-width">
                <mat-chip-list #customerChipList>
                    <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(1)" [selectable]="false"
                        [removable]="true" (removed)="popMultipleSelection(1, item.SearchId, item.SearchStr)">
                        {{item.Title}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input matInput [matChipInputFor]="customerChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="false" #customerAutoCompleteInput (focus)="focus(1)" placeholder="{{ Translate('Customer')}}"
                        aria-label="customer" [matAutocomplete]="autoCustomer" [formControl]="customerCtrl"  >
                </mat-chip-list>
                <mat-autocomplete #autoCustomer="matAutocomplete" [displayWith]="customerDisplayMapper"
                    (optionSelected)="customerSelected($event,customerAutoCompleteInput )">
                    <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
                        <!--<img style="vertical-align:middle;" aria-hidden src="" height="25" />-->
                        <span>{{ customer.Title }}</span>
                        <small></small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="header-form-full-width">
                <mat-chip-list #jobsiteChipList>
                    <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(2)" [selectable]="false"
                        [removable]="true" (removed)="popMultipleSelection(2, item.SearchId, item.SearchStr)">
                        {{item.Title}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input matInput [matChipInputFor]="jobsiteChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="false" (focus)="focus(2)" #jobSiteAutoCompleteInput placeholder="{{ Translate('Job Site')}}"
                        aria-label="jobsite" [matAutocomplete]="autoJobsite" [formControl]="jobsiteCtrl"  >
                </mat-chip-list>
                <mat-autocomplete #autoJobsite="matAutocomplete" [displayWith]="jobsiteDisplayMapper" (optionSelected)="jobsiteSelected($event, jobSiteAutoCompleteInput)">
                    <mat-option *ngFor="let jobsite of filteredJobsites | async" [value]="jobsite">
                        <!--<img style="vertical-align:middle;" aria-hidden src="" height="25" />-->
                        <span>{{ jobsite.Title }}</span>
                        <small></small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
         
            <mat-form-field class="header-form-full-width">
                <mat-chip-list #familyChipList>
                    <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(4)" [selectable]="false"
                        [removable]="true" (removed)="popMultipleSelection(4, item.SearchId, item.SearchStr)">
                        {{item.Title}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input matInput [matChipInputFor]="familyChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="false" (focus)="focus(4)" #familyAutoCompleteInput placeholder="{{ Translate('Family')}}"
                        aria-label="Family" [matAutocomplete]="autoFamily" [formControl]="familyCtrl">
                </mat-chip-list>
                <mat-autocomplete #autoFamily="matAutocomplete" [displayWith]="familyDisplayMapper" (optionSelected)="familySelected($event,familyAutoCompleteInput)">
                    <mat-option *ngFor="let family of filteredFamilies | async" [value]="family">
                        <span>{{ family.Title }}</span> |
                        <small>{{family.Symbol}}</small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="header-form-full-width">
                <mat-chip-list #makeChipList>
                    <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(5)" [selectable]="false"
                        [removable]="true" (removed)="popMultipleSelection(5, item.SearchId, item.SearchStr)">
                        {{item.Title}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input matInput [matChipInputFor]="makeChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="false" (focus)="focus(5)" #makeAutoCompleteInput placeholder="{{ Translate('Make')}}"
                        aria-label="Make" [matAutocomplete]="autoMake" [formControl]="makeCtrl">
                </mat-chip-list>
                <mat-autocomplete #autoMake="matAutocomplete" [displayWith]="makeDisplayMapper" (optionSelected)="makeSelected($event,makeAutoCompleteInput )">
                    <mat-option *ngFor="let make of filteredMakes | async" [value]="make">
                        <span>{{ make.Title }}</span> |
                        <small>{{make.Symbol}}</small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="header-form-full-width">
                <mat-chip-list #modelChipList>
                    <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(6)" [selectable]="false"
                        [removable]="true" (removed)="popMultipleSelection(6, item.SearchId, item.SearchStr)">
                        {{item.Title}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input matInput [matChipInputFor]="modelChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="false" (focus)="focus(6)" #modelAutoCompleteInput placeholder="{{ Translate('Model')}}"
                        aria-label="Model" [matAutocomplete]="autoModel" [formControl]="modelCtrl">
                </mat-chip-list>
                <mat-autocomplete #autoModel="matAutocomplete" [displayWith]="modelDisplayMapper" (optionSelected)="modelSelected($event,modelAutoCompleteInput)">
                    <mat-option *ngFor="let model of filteredModels | async" [value]="model">
                        <span>{{ model.Title }}</span>
                        <small></small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="header-form-full-width">
                <mat-chip-list #equipmentChipList>
                    <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(3)" [selectable]="false"
                        [removable]="true" (removed)="popMultipleSelection(3, item.SearchId, item.SearchStr)">
                        {{item.Title}}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input matInput [matChipInputFor]="equipmentChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        [matChipInputAddOnBlur]="false" (focus)="focus(3)" (input)="MakeChangedMain($event)" #equipmentAutoCompleteInput placeholder="{{ Translate('Equipment Serial/Unit No')}}"
                        aria-label="Equipment" [matAutocomplete]="autoEquipment" [formControl]="equipmentCtrl" >
                </mat-chip-list>
                <mat-autocomplete #autoEquipment="matAutocomplete" [displayWith]="equipmentDisplayMapper"
                    (optionSelected)="equipmentSelected($event,equipmentAutoCompleteInput )" >
                    <mat-option *ngFor="let equipment of filteredEquipments | async" [value]="equipment" >
                        <span>{{ equipment.Serial }}</span> |
                        <small> {{ equipment.Unit }} </small>
                        <small *ngIf="equipment.AddiUnit!=null"> | {{ equipment.AddiUnit }} </small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
           
            <input  style="height: 45px;" class="header-form-full-width" placeholder="{{ Translate('Serial/Unit Search')}}" name="eqsearch_" [(ngModel)]="eqSearch" (blur)="ChangeEQSearch(22,$event)">
           
            <!-- <mat-form-field class="header-form-full-width" appearance="outline">
                
                <mat-label> {{Translate('Serial/Unit Search')}}</mat-label>
                <input matInput >
            </mat-form-field> -->

            <mat-form-field  class="header-form-full-width" *ngIf="selectionLists.examinerList.length>0  && isNotUnsyncInspection">
                <mat-chip-list #examinerChipList>
                  <mat-chip class="input-chips" *ngFor="let item of getPushedSelections(20)" [selectable]="false"
                      [removable]="true" (removed)="popMultipleSelection(20, item.SearchId, item.SearchStr)">
                      {{item.Title}}
                      <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                  <input matInput [matChipInputFor]="examinerChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      [matChipInputAddOnBlur]="false" #examinerAutoCompleteInput (focus)="focus(20)" placeholder="{{ Translate('Inspector')}}"
                      aria-label="examiner" [matAutocomplete]="autoExaminer" [formControl]="examinerCtrl"  >
              </mat-chip-list>
              <mat-autocomplete #autoExaminer="matAutocomplete" [displayWith]="examinerDisplayMapper"
                  (optionSelected)="examinerSelected($event,examinerAutoCompleteInput )">
                  <ng-container *ngFor="let examiner of filteredExaminers | async">
                    <mat-option *ngIf="examiner.Title && examiner.Title.trim() !== ''" [value]="examiner">
                      {{ examiner.Title}}
                    </mat-option>
                  </ng-container>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="header-form-full-width" *ngIf="WorkshopRepair == true">
                <mat-label>{{'Inspection Type' | translate | async}}</mat-label>
                <mat-select [(ngModel)]="selectedComponentType" (selectionChange)="ChangeselectedComponentType($event)" name="compInspectiontype_">
                  <mat-option *ngFor="let ty of ComponentList" [value]="ty.Id">
                    {{ty.Name}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <div  class="header-form-full-width">
            </div>
            <div class="bottom-row" *ngIf="showWval">
                <section class="bottom-row__left" >
                    <span>{{Translate('Evaluation (Worst Side)')}}</span>
                    <mat-checkbox *ngIf="inspectionType !== 'temperature'" [checked]="getEvalCheckStatus(8)" (change)="checkBoxChanged(8,$event)" class="evaluation-check-a">
                        {{Translate('A')}}
                    </mat-checkbox>
                    <mat-checkbox *ngIf="inspectionType !== 'temperature'" [checked]="getEvalCheckStatus(9)" (change)="checkBoxChanged(9,$event)" class="evaluation-check-b">
                        {{Translate('B')}}
                    </mat-checkbox>
                    <mat-checkbox *ngIf="inspectionType !== 'temperature'" [checked]="getEvalCheckStatus(10)" (change)="checkBoxChanged(10,$event)" class="evaluation-check-c">
                        {{Translate('C')}}
                    </mat-checkbox>
                    <mat-checkbox *ngIf="inspectionType !== 'temperature'" [checked]="getEvalCheckStatus(11)" (change)="checkBoxChanged(11,$event)" class="evaluation-check-x">
                        {{Translate('X')}}
                    </mat-checkbox>
                    <mat-checkbox *ngIf="inspectionType === 'thermography' || inspectionType === 'temperature'" [checked]="getEvalCheckStatus(26)" (change)="checkBoxChanged(26,$event)" class="evaluation-check-mr">
                        {{Translate('MR')}}
                    </mat-checkbox>
                    <mat-checkbox *ngIf="inspectionType === 'thermography' || inspectionType === 'temperature'" [checked]="getEvalCheckStatus(27)" (change)="checkBoxChanged(27,$event)" class="evaluation-check-m">
                        {{Translate('M')}}
                    </mat-checkbox>
                    <div class="dates" [hidden]="!showDateInputs">
                        <mat-form-field>
                            <input matInput [matDatepicker]="startDatePicker" placeholder="{{'Start Date'|translate | async}}" [(ngModel)]="startDate"
                               [formControl]="StartDateControl">
                            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #startDatePicker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field class="header-form-width-date">
                            <input matInput [matDatepicker]="endDatePicker" placeholder="{{'End Date'|translate|async}}" [(ngModel)]="endDate"
                                 [formControl]="EndDateControl">
                            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #endDatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="dates" [hidden]="showDateInputs">
                        <span style="margin-right: 10px;"> {{Translate('Equipment not in Use')}}</span>
                        <mat-checkbox  [checked]="eqNotInUseSearch_" (change)="ChangeEqNotInUseSearch(23,$event)">
                        </mat-checkbox>
                    </div>
                </section>
                <mat-form-field class="header-form-width" *ngIf="WorkshopRepair == true">
                    <mat-label>{{'Job Status' | translate | async}}</mat-label>
                    <mat-select [(ngModel)]="wSREStatusID"  name="wsreInspectiontype_" (selectionChange)="StatusChanges($event)" multiple>
                      <mat-option *ngFor="let ty of WSREStatus" [value]="ty.StatusId">
                        {{ty.StatusName}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="flex flex--align-center">
                    <a class="button" (click)="resetSelection(); submitSelection();ResetButtonClick();
                    clearInputBoxes(modelAutoCompleteInput,makeAutoCompleteInput,familyAutoCompleteInput,customerAutoCompleteInput,jobSiteAutoCompleteInput,equipmentAutoCompleteInput,dealerAutoCompleteInput );"><span class="button__text">{{Translate('Reset')}}</span></a>
                    <a class="button button--primary" (click)="submitSelection()"><i class="material-icons button__icon">search</i><span
                            class="button__text">{{Translate('Search')}}</span></a>
                </div>
            </div>
            <div class="bottom-row" *ngIf="!showWval">
                <section class="bottom-row__left" >
                   

                </section>
                <div class="flex flex--align-center">
                    <a class="button" (click)="resetSelection(); ResetButtonClick();submitSelection();
                    clearInputBoxes(modelAutoCompleteInput,makeAutoCompleteInput,familyAutoCompleteInput,customerAutoCompleteInput,jobSiteAutoCompleteInput,equipmentAutoCompleteInput,dealerAutoCompleteInput );"><span class="button__text">{{Translate('Reset')}}</span></a>
                    <a class="button button--primary" (click)="submitSelection()"><i class="material-icons button__icon">search</i><span
                            class="button__text">{{Translate('Search')}}</span></a>
                </div>
            </div>
        </form>
    </div>
</div>
